<template>
  <div id="sendPointsToGeocoding">
    <el-row>
      <el-col>
        <Title title="Enviar puntos a geocoding"
          subtitle="Busca las ordenes y envia a geocoding.">
        </Title>
      </el-col>
      <el-col>
        <TableSPTG v-model="list"/>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import Title from '../components/base/Title.vue';
import TableSPTG from '../components/sendPointsToGeocoding/TableSPTG.vue';
import FindOrders from '../components/sendPointsToGeocoding/FindOrders.vue';


export default {
  name: 'SendPointsToGeocoding',
  components: {
    Title,
    TableSPTG,
    FindOrders,
  },
  props: {
    value: {
      type: Array,
      default() {
        return [];
      },
    },
  },
  data() {
    return {
      list: [],
    };
  },
};
</script>

<style lang="scss" scoped>
.right {
  float: right;
}

.mt-1{
  margin-top: 1rem;
}
</style>
